
import { defineComponent } from 'vue'
import { useOrganizationModule } from '@/modules/organizations'
import { useRoute } from 'vue-router'
import OrganizationsBillingTemplatesList from '@/components/organizations/billing-templates-list.vue'
import OrganizationsShowEditOrganization from '@/components/organizations/show-edit-organization.vue'
import { OrganizationsRouteNames } from '@/router/routes-names'

export default defineComponent({
    name: 'view-organizations-show-organization',
    components: { OrganizationsBillingTemplatesList, OrganizationsShowEditOrganization },
    async setup () {
        const { getOrganization } = useOrganizationModule()
        const route = useRoute()

        const organizationId = route.params.organizationId as string
        const organization = await getOrganization(organizationId)

        const organizationsListRoute = { name: OrganizationsRouteNames.LIST, query: { page: route.query.page } }

        return {
            route,
            organization,
            organizationId,
            OrganizationsRouteNames,
            organizationsListRoute
        }
    }
})
